import { useEffect } from 'react';
import { useFormik } from 'formik';
import { CasesGeneralInformation } from '../../../../../../shared/types/modules/cases-general-information';

export const useCasoDetailGeneralInfo = (
    casesGeneralInformation?: CasesGeneralInformation
) => {
    const formik = useFormik({
        initialValues: {
            created_at: '',
            callId: '',
            createdBy: '',
            updatedBy: '',
            channel: '',
            typification1: '',
            typification2: '',
            typification3: '',
            typification4: '',
            typification5: '',
            observation: '',
            document: '',
            vehiclePlate: '',
            policyNumber: '',
            branch: '',
            userAttendanceId: '',
            userAttendanceName: '',
        },
        onSubmit: console.log,
    });

    useEffect(() => {
        const {
            created_at = '',
            callId: callInfoRaw = '',
            createdBy: createdByRaw = '',
            updatedBy: updatedByRaw = '',
        } = casesGeneralInformation || {};
        const callInfo =
            typeof callInfoRaw === 'string'
                ? callInfoRaw
                : (callInfoRaw as string) || '';
        const createdBy =
            createdByRaw && typeof createdByRaw === 'object'
                ? `${createdByRaw.name ?? ''} ${
                    createdByRaw.surname ?? ''
                }`.trim()
                : '';
        const updatedBy =
            createdByRaw && typeof updatedByRaw === 'object'
                ? `${updatedByRaw.name ?? ''} ${
                    updatedByRaw.surname ?? ''
                }`.trim()
                : '';
        const formattedCreatedAt =
            created_at instanceof Date
                ? created_at.toISOString()
                : created_at || '';
        const channelName =
            typeof casesGeneralInformation?.channel === 'object' &&
            casesGeneralInformation?.channel?.name
                ? casesGeneralInformation.channel.name
                : '';
        const typificationName1 =
            typeof casesGeneralInformation?.typification1 === 'object' &&
            casesGeneralInformation?.typification1?.name
                ? casesGeneralInformation.typification1.name
                : '';
        const typificationName2 =
            typeof casesGeneralInformation?.typification2 === 'object' &&
            casesGeneralInformation?.typification2?.name
                ? casesGeneralInformation.typification2.name
                : '';
        const typificationName3 =
            typeof casesGeneralInformation?.typification3 === 'object' &&
            casesGeneralInformation?.typification3?.name
                ? casesGeneralInformation.typification3.name
                : '';
        const typificationName4 =
            typeof casesGeneralInformation?.typification4 === 'object' &&
            casesGeneralInformation?.typification4?.name
                ? casesGeneralInformation.typification4.name
                : '';
        const typificationName5 =
            typeof casesGeneralInformation?.typification5 === 'object' &&
            casesGeneralInformation?.typification5?.name
                ? casesGeneralInformation.typification5.name
                : '';
        const branchName =
            typeof casesGeneralInformation?.branch === 'object' &&
            casesGeneralInformation?.branch?.name
                ? casesGeneralInformation.branch.name
                : '';
        formik.setValues({
            created_at: formattedCreatedAt,
            callId: callInfo,
            createdBy,
            updatedBy,
            channel: channelName,
            typification1: typificationName1,
            typification2: typificationName2,
            typification3: typificationName3,
            typification4: typificationName4,
            typification5: typificationName5,
            observation: casesGeneralInformation?.observation || '',
            document: casesGeneralInformation?.document || '',
            vehiclePlate: casesGeneralInformation?.vehiclePlate || '',
            policyNumber: casesGeneralInformation?.policyNumber || '',
            branch: branchName,
            userAttendanceId: casesGeneralInformation?.userAttendanceId || '',
            userAttendanceName:
                casesGeneralInformation?.userAttendanceName || '',
        });
    }, [casesGeneralInformation]);

    return {
        formik,
    };
};
